<template>
    <div class="container">
      <el-carousel
        trigger="click"
        arrow="never"
        height="360px"
      >
        <el-carousel-item>
          <div class="content-row">
            <div class="row-left">
              <div class="img-wrap">
                <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/tkjl_uav_img1.png" alt="">
            </div>
            </div>
            <div class="row-right">
              <div class="block-text">
                <div class="title">Mini系列</div>
                <div class="desc">
                    DJI Mini、DJI Mini2系列、DJI Mini 3、DJI Mini 3 Pro
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
  
        <el-carousel-item>
          <div class="content-row">
            <div class="row-left">
              <div class="img-wrap">
                <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/tkjl_uav_img2.png" alt="">
            </div>
            </div>
            <div class="row-right">
              <div class="block-text">
                <div class="title">Air系列</div>
                <div class="desc">
                    DJI Air、DJI Air 2系列
                 </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
  
        <el-carousel-item>
          <div class="content-row">
            <div class="row-left">
              <div class="img-wrap">
                <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/tkjl_uav_img3.png" alt="">
            </div>
            </div>
            <div class="row-right">
              <div class="block-text">
                <div class="title">Mavic系列</div>
                <div class="desc">
                    Mavic 2 系列、DJI Mavic 3 行业系列、DJI Mavic 3 多光谱版
                 </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
  
        <el-carousel-item>
          <div class="content-row">
            <div class="row-left">
              <div class="img-wrap">
                <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/tkjl_uav_img4.png" alt="">
            </div>
            </div>
            <div class="row-right">
              <div class="block-text">
                <div class="title">精灵系列</div>
                <div class="desc">
                    Phantom4精灵系列
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
  
        <el-carousel-item>
          <div class="content-row">
            <div class="row-left">
              <div class="img-wrap">
                <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/tkjl_uav_img5.png" alt="">
            </div>
            </div>
            <div class="row-right">
              <div class="block-text">
                <div class="title">多轴跟踪</div>
                <div class="desc">
                    经纬MatriceM210、M300系列、Matrice 30系列、Matrice 300 RTK、Matrices 350 RTK
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {};
    },
  };
  </script>
  
  <style lang="stylus" scoped>
  /deep/.el-carousel__button {
      background-color: #E0E0E0;
  }
  /deep/.el-carousel__indicator.is-active button {
      background-color:#2372E9;
  }
  /deep/.el-carousel__indicators--horizontal {
    width:270px !important;
    display:flex;
    justify-content:center;
  }
    .content-row {
              display:flex;
              flex-direction: column;
              margin-bottom:4rem;
              >div {
                  flex:1;
              }
              .img-wrap {
                  display:flex;
                  justify-content: center;
                  align-items: center;
              }
              .row-left {
                  .img-wrap {
                      max-height:314px !important;
                      overflow:hidden;
                      display:flex;
                      justify-content: center;
                      align-items: center;
                  }
                  img {
                      width:100%;
                  }
              }
              .block-text {
                  padding:17px 0 10px;
                  .title {
                      color:#2372E9;
                      margin-bottom:10px;
                      font-size:18px;
                      text-align:center;
                  }
                  .desc {
                      color:#333333;
                      line-height:30px;
                      font-size:1.25rem;
                      text-align:center;
                  }
              }
          }
  </style>
  